import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import { FiPlus, FiX, FiClipboard } from "react-icons/fi";

import SidebarNav from "../../components/MasterSideBar.jsx";
import TopbarNav from "../../components/TopbarNav";
import ReportCaseForm from "../../components/ReportCaseForm";
import MyCases from "../../components/MyCases";

const PMDiscipline = () => {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decoded = jwtDecode(token);
            setUserId(decoded.id || decoded.userId || decoded._id);
        } else navigate("/");
    }, [navigate]);

    return (
        <div className="flex min-h-screen bg-gray-50 font-sans overflow-hidden">
            <ToastContainer theme="colored" />
            <SidebarNav visible={sidebarOpen} onClose={() => setSidebarOpen(false)} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} onLogout={() => { localStorage.clear(); navigate("/"); }} />

            <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0 md:ml-64'}`}>
                <TopbarNav onSidebarToggle={() => setSidebarOpen(true)} />
                <main className="flex-1 p-4 md:p-8 mt-16 lg:mt-20 overflow-y-auto">
                    <div className="max-w-[1400px] mx-auto space-y-6">
                        <div className="flex justify-between items-center">
                            <div>
                                <h1 className="text-2xl md:text-3xl font-black text-gray-800 uppercase tracking-tight">Discipline</h1>
                                <p className="text-gray-500 text-sm">Case management and reporting.</p>
                            </div>
                            <button onClick={() => setShowForm(true)} className="bg-orange-600 text-white px-6 py-3 rounded-xl font-black uppercase text-xs tracking-widest hover:bg-orange-700 shadow-lg flex items-center gap-2"><FiPlus/> New Case</button>
                        </div>

                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden min-h-[500px]">
                            <div className="p-6 border-b border-gray-50 bg-gray-50/30 font-black text-xs uppercase tracking-widest text-gray-400">Recorded Cases</div>
                            <div className="p-6">{userId && <MyCases userId={userId} />}</div>
                        </div>
                    </div>
                </main>
            </div>

            {showForm && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setShowForm(false)}></div>
                    <div className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl relative flex flex-col max-h-[90vh]">
                        <div className="p-6 border-b flex justify-between items-center">
                            <h2 className="text-xl font-black text-gray-800 uppercase tracking-tight">Report Incident</h2>
                            <button onClick={() => setShowForm(false)} className="p-2 hover:bg-gray-100 rounded-full"><FiX size={24}/></button>
                        </div>
                        <div className="p-8 overflow-y-auto"><ReportCaseForm reporterId={userId} onClose={() => {setShowForm(false); toast.success("Case reported!");}} /></div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default PMDiscipline;